import { DataGridCtrl } from '../controllers/DataGridCtrl';
import { Module } from '../Module';

// Example usage:
//
//   tb:template-list(templates="headers")
//     tb:template(key="name")
//       span Name
//     tb:template(key="value")
//       span Value
//
//   tb:template-list(templates="cells")
//     tb:template
//       span {{row.name}}
//     tb:template
//       span {{row.value}}
//
//   tb:data-grid(
//       headers="headers",
//       cells="cells",
//       items="items",
//       current-row-index="currentRowIndex",
//       always-have-current-row="true",
//       is-row-selected="isRowSelected(row)",
//       header-clicked="headerClicked(header)",
//       row-clicked="rowClicked(row, colIndex)"
//       slice-changed="sliceChanged(newSlice)")
//
// "headers" is an array of ITemplate objects that define the contents of the headers.
// "cells" is an array of ITemplate objects that define the contents of the cells.
// "items" is an ISliceable. The data grid will fetch the slice to populate the grid.
// "current-row-index" is the index of the 'current' row (the definition of 'current' depends on context).
// "always-have-current-row" means there will always be a current row (i.e. current-row-index will only be -1 if the grid is empty)
// "is-row-selected" is a callback (row => boolean) that determines whether each row is shown as selected.
// "header-clicked" is a callback (header => void) that is called when a header is clicked.
// "row-clicked" is a callback (row, colIndex? => void) that is called when a row is clicked.
// The colIndex parameter to the "row-clicked" callback is the index (zero-based) of the column that was clicked,
// or undefined if the click occurred outside any column.
// "slice-changed" is a callback (newSlice => void) that is called whenever the "slice" of visible rows is updated.
// The "newSlice" parameter is of type ListResult<any>, where the values are the rows.
//
// The cell templates' scope is extended with the following properties:
// "row": the row object
// "slice" the current slice (see slice-changed above)

Module.instance().directive('tbDataGrid', () => {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'dataGrid.html',
    scope: {
      headers: '=',
      cells: '=',
      items: '=',
      currentRowIndex: '=?',
      currentRowObject: '=?',
      columnWidths: '=?',
      alwaysHaveCurrentRow: '=',
      isRowSelected: '&',
      headerClicked: '&',
      rowClicked: '&',
      rowsClickable: '=',
      rowHeight: '=?',
      sliceChanged: '&',
      emptyTemplate: '=?',
      emptyTemplateModel: '=?'
    },
    controller: DataGridCtrl
  };
});
